module.exports = __webpack_public_path__ + "img/card.369d223d.png";